import { EFinancingCompany, EFinancingProgram } from '@if/core/types'
import FeatureFlags from './FeatureFlags'

interface FinancingCompany {
  Id: EFinancingCompany
  FinancingPrograms: EFinancingProgram[]
}

const companies: FinancingCompany[] = [
  {
    Id: EFinancingCompany.IFinance,

    FinancingPrograms: [EFinancingProgram.Personal, EFinancingProgram.B2c],
  },
  {
    Id: EFinancingCompany.Iceberg,
    FinancingPrograms: [
      EFinancingProgram.Auto,
      EFinancingProgram.IfXpress,
      EFinancingProgram.Products,
      EFinancingProgram.AutoRsla,
      EFinancingProgram.CreditRsla,
      EFinancingProgram.MechanicalWarranty,
      EFinancingProgram.EasyCareProtectionPlan,
    ],
  },
]

/**
 * Programs of the given companies. Pass the feature flags to leave out the programs whose feature switch is off
 * (for screens that create applications; searches over existing applications should not pass them).
 */
export const getProgramsByCompanyId = (
  companyIds: EFinancingCompany[],
  featureFlags?: FeatureFlags,
): EFinancingProgram[] => {
  const programs: EFinancingProgram[] = []
  companyIds.forEach((companyId) => {
    const company = companies.find((x) => x.Id === companyId)
    if (company) {
      programs.push(...company.FinancingPrograms)
    }
  })
  if (!featureFlags) return programs

  return programs.filter(
    (x) =>
      (featureFlags.useIFXFinancingProgram || x !== EFinancingProgram.IfXpress) &&
      (featureFlags.enableAutoPlus || x !== EFinancingProgram.Auto) &&
      (featureFlags.enableEasyCare || x !== EFinancingProgram.EasyCareProtectionPlan),
  )
}

export const getCompanyIdByProgram = (program: EFinancingProgram): EFinancingCompany => {
  const company = companies.find((company) => company.FinancingPrograms.includes(program))
  if (!company) {
    throw new Error(`No company found for financing program: ${program}`)
  }
  return company.Id
}

export default companies
